module.exports = __webpack_public_path__ + "static/media/22.ba514871.webp";